import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Components/AIML/ShowQuantAnalysis";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const ShowQuantAnalysisTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="ShowQuantAnalysis">
      <TabletNotice page="ShowQuantAnalysis" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default ShowQuantAnalysisTablet;